"use client";

import { cn } from "../../utils/cn";

type StatusBadgeProps = {
  label: string;
  variant?: "success" | "warning" | "error" | "info" | "neutral";
  className?: string;
};

const variantStyles: Record<
  NonNullable<StatusBadgeProps["variant"]>,
  string
> = {
  success: "bg-green-50 text-green-700",
  warning: "bg-yellow-50 text-yellow-700",
  error: "bg-red-50 text-red-700",
  info: "bg-blue-50 text-blue-700",
  neutral: "bg-gray-100 text-gray-600",
};

export function StatusBadge({
  label,
  variant = "neutral",
  className,
}: StatusBadgeProps) {
  return (
    <span
      data-testid="status-badge"
      className={cn(
        // `shrink-0 whitespace-nowrap`: every caller puts this beside a label in
        // a flex row, so without them the badge is the thing that gives way —
        // "Ready to install" wrapped to two lines and broke out of its own pill.
        // The label truncates instead, which is the half that can afford to.
        "inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-base font-medium",
        variantStyles[variant],
        className,
      )}
    >
      {label}
    </span>
  );
}
